import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { TrackingCard } from '../components/TrackingCard';
import { useWhatsappOnboarding } from '../hooks/useWhatsappOnboardding';

export const WhatsappOnboarding = () => {
  const { isLoading, user, fbLoaded, handleEmbeddedSignup, signupError } =
    useWhatsappOnboarding();
  return (
    <div className="dark">
      <Header />
      <section className="dark:bg-gray-900 h-full">
        <div className={`flex flex-col items-center space-y-4`}>
          <div className="bg-card flex flex-col justify-center rounded-lg shadow-lg p-6 max-w-4xl w-full mt-12">
            {user?.whatsappOnboarding &&
            Object.keys(user.whatsappOnboarding).length > 0 ? (
              <TrackingCard data={user.whatsappOnboarding} />
            ) : (
              <>
                <div className="text-center mb-6">
                  <div className="flex justify-center mb-4">
                    <div className="bg-green-100 p-3 rounded-full">
                      <svg
                        className="w-8 h-8 text-green-600"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                      </svg>
                    </div>
                  </div>
                  <h2 className="text-2xl font-bold text-white mb-2">
                    WhatsApp Business Setup
                  </h2>
                  <p className="text-gray-200">
                    Connect your business to WhatsApp in just a few clicks
                  </p>
                </div>

                <button
                  onClick={handleEmbeddedSignup}
                  disabled={!fbLoaded || isLoading}
                  className={`w-1/2 self-center flex items-center justify-center px-4 py-3 rounded-lg font-semibold text-white transition-all duration-200 ease-in-out transform
                    ${
                      !fbLoaded || isLoading
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl'
                    }
                  `}
                >
                  {isLoading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      Setting up...
                    </>
                  ) : (
                    <>
                      <svg
                        className="w-5 h-5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                      </svg>
                      Continue with Facebook
                    </>
                  )}
                </button>

                <div className="mt-4 text-xs text-gray-500 text-center">
                  By continuing, you agree to WhatsApp's Terms of Service and
                  Privacy Policy
                </div>

                {signupError ? (
                  <div className="mt-5">
                    <p className="text-red-400 ">Error: {signupError}</p>
                  </div>
                ) : null}
                <p className="text-center text-white mt-5">
                  <Link className="text-blue-600" to="/#contact">
                    Contact Us
                  </Link>{' '}
                  for more support!
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};
